// extracted by mini-css-extract-plugin
export default {"container":"ArchiveStatus_container__6yir9","containerError":"ArchiveStatus_containerError__0gLT3","containerSuccess":"ArchiveStatus_containerSuccess__wOdlK"};